export default {
    INITIALIZE: 'ADS/INITIALIZE',
    SET_TCF_LOADED: 'ADS/SET_TCF_LOADED',
    SET_ADS: 'ADS/SET_ADS'
};
